// pdfjs-dist 5 (pulled in by react-pdf for the signing-page preview and the
// Resources brochure viewer) calls a few browser APIs newer than the last
// Chrome/Edge that runs on Windows 7/8/8.1 (v109) or Firefox ESR 115. CRA's
// Babel setup transpiles syntax but doesn't polyfill these, so on those
// browsers the signing page threw before rendering. Must be imported before
// anything else in index.js.

// Chrome 119 / Firefox 121
if (typeof Promise.withResolvers !== "function") {
  Promise.withResolvers = function () {
    let resolve;
    let reject;
    const promise = new this((res, rej) => {
      resolve = res;
      reject = rej;
    });
    return { promise, resolve, reject };
  };
}

// Chrome 126 / Firefox 126
if (typeof URL.parse !== "function") {
  URL.parse = function (url, base) {
    try {
      return base === undefined ? new URL(url) : new URL(url, base);
    } catch (e) {
      return null;
    }
  };
}

// Chrome 120 / Firefox 120
if (typeof URL.canParse !== "function") {
  URL.canParse = function (url, base) {
    return URL.parse(url, base) !== null;
  };
}

// Chrome 116 / Firefox 124
if (
  typeof AbortSignal !== "undefined" &&
  typeof AbortSignal.any !== "function"
) {
  AbortSignal.any = function (signals) {
    const controller = new AbortController();
    for (const signal of signals) {
      if (signal.aborted) {
        controller.abort(signal.reason);
        return controller.signal;
      }
    }
    const onAbort = (event) => {
      controller.abort(event.target.reason);
      for (const signal of signals) {
        signal.removeEventListener("abort", onAbort);
      }
    };
    for (const signal of signals) {
      signal.addEventListener("abort", onAbort);
    }
    return controller.signal;
  };
}
